import { Outlet } from 'react-router-dom';

import WorkflowLayout from '@/components/layouts/WorkflowLayout';

export default function Workflows() {
  return (
    <>
      <WorkflowLayout>
        <Outlet />
      </WorkflowLayout>
    </>
  );
}
